<template>
<div id="layout_apendices" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-top justify-top>
            <v-menu-lateral-apendice />
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" :title="title" class="px-5 py-3" >
                    <v-card-actions>

                        <v-spacer></v-spacer>
                        <v-speed-dial direction="left" open-on-hover>
                            <template v-slot:activator>
                                <v-btn x-small fab dark color="primary" >
                                    <v-icon>reorder</v-icon>
                                </v-btn>
                            </template>
                            <exportar-excel v-tippy style="cursor: pointer" :data="datafiltered" :exportFields="camposexcel" :name="title + '.xlsx'" >
                                <v-btn fab x-small dark color="success" title="Exportar" v-tippy>
                                    <v-icon dark>get_app</v-icon>
                                </v-btn>
                            </exportar-excel>
                            <upload-excel-component v-if="editable" :on-success="handleSuccess" :before-upload="beforeUpload" />
                            <exportar-excel v-if="editable" :data="camposLayout" :exportFields="encabezadoLayout" :name="'Layout ' + title + '.xlsx'" >
                                <v-btn fab dark x-small color="purple darken-2" title="Descargar Layout" v-tippy>
                                    <v-icon dark>receipt</v-icon>
                                </v-btn>
                            </exportar-excel>
                        </v-speed-dial>

                        <v-btn v-if="editable" fab dark x-small color="secondary" slot="activator" @click.native="openModal(1)" title="Agregar Registro" v-tippy>
                            <v-icon dark>add</v-icon>
                        </v-btn>
                    </v-card-actions>
                    <v-dialog v-model="modal" max-width="40%" style=" z-index: 400 !important;" >
                        <v-card>
                            <v-card-title>

                                <v-power-titulo :icon="update ? 'edit' : 'add'" :title="update ? 'Actualizar Registro' : 'Nuevo Registro'" tipo="modal" />

                                <v-spacer></v-spacer>
                                <v-btn icon @click.native="modal = false" class="close_modal" >
                                    <v-icon class="white--text" >cancel</v-icon>
                                </v-btn>
                            </v-card-title>
                            <v-form ref="form" lazy-validation>
                                <v-card-text>
                                    <v-container grid-list-md text-xs-center @keyup.enter="guardar()" >
                                        <v-layout row wrap>
                                            <v-flex s12 m12 l12>
                                                <v-text-field label="Clave" type="text" v-model="model.clave" :rules="[rules.required]" maxlength="10" ></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout row wrap>
                                            <v-flex s12 m12 l12>
                                                <v-text-field label="Descripción" type="text" v-model="model.nombre" :rules="[rules.required]" maxlength="200" ></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout row wrap>
                                            <v-flex s12 m12 l12>
                                                <!--OptionCombo: 1-Pais, 2-Pais,Estado, 3-Pais,Estado,Ciudad, 4-Pais,Estado,Municipio, 5-Pais,Estado,Ciudad,Municipio -->
                                                <v-combo-paises :option_combos="1" :param_pais="model.pais" :on-select-pais="selectComboPais" />
                                            </v-flex>
                                        </v-layout>

                                    </v-container>
                                </v-card-text>
                            </v-form>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn @click.native="modal = false" >
                                    <v-icon>cancel</v-icon>Cancelar
                                </v-btn>
                                <v-btn color="success" :loading="loading" @click.native="guardar()" >
                                    <v-icon>done</v-icon>
                                    {{ update ? "Actualizar" : "Guardar" }}
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                    <v-card-text>
                        <div id="datagrid" >

                            <v-client-table ref="vuetable" :data="datos.items" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                                </template>
                                <template slot="filter__pais" >
                                    <v-combobox v-model="sel_pais" :items="paises_estados" :item-text="nombrePais" item-value="id" placeholder="Filtrar por Pais" class="form-control" solo clearable @change="applyFilter()" ></v-combobox>
                                </template>
                                <template slot="actions" slot-scope="props" >
                                    <v-speed-dial v-if="id_cliente == 0 || props.row.cliente == id_cliente" direction="left" :open-on-hover="true" >
                                        <v-btn slot="activator" x-small fab dark color="primary" >
                                            <v-icon>reorder</v-icon>
                                        </v-btn>

                                        <v-btn x-small fab dark color="blue" @click.native="getRegistro(props.row.id)" title="Editar Registro" v-tippy>
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="pink" @click.native="deleteRegistro(props.row.id)" title="Eliminar Registro" v-tippy>
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </v-speed-dial>
                                </template>
                            </v-client-table>
                        </div>
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>

</div>
</template>

<script>
import axios from "axios";

import ComboPaises from '@/components/ComboPaises/index.vue';
import menuLateral from "@/views/apendices/MenuLateralApendice.vue";
import powerTitulo from "@/components/powerTitulo.vue";
import {
    Event
} from 'vue-tables-2';

export default {
    components: {
        "v-power-titulo": powerTitulo,
        "v-combo-paises": ComboPaises,
        "v-menu-lateral-apendice": menuLateral,
    },
    mounted() {},

    data: () => ({
        fab: false,
        name: "datagrid",
        importData: [],
        sel_pais: "",
        paises_estados: [],
        show_loading: true,
        loading: false,
        modal: false,
        update: false,
        url_active: location.href,
        id_cliente: 0,
        editable: true,
        datos: {
            items: []
        },
        rules: {
            required: v => !!v || "Este campo es requerido"
        },
        url_actions: "apendices/",
        url_list: "apendices/lista/",
        tabla: 22,
        title: "CLAVES DE ESTADOS",
        paises: [],
        estados: [],
        columns: ["clave", "nombre", "pais", "actions"],
        options: {
            filterable: ["clave", "nombre"],
            sortable: ["clave", "nombre", "pais"],
            customFilters: [{
                name: 'porpais',

                callback: function (row, query) {
                    return row.pais == query.clave_m3 + ' - ' + query.nombre;
                }
            }],
            headings: {
                clave: "Clave",
                nombre: "Nombre Estado",
                pais: "País",
                actions: "Operaciones"
            },
        },
        camposexcel: {
            Clave: "clave",
            "Nombre Estado": "nombre",
            País: "pais"
        },
        encabezadoLayout: {
            clave: "clave",
            nombre: "nombre",
            pais: "pais"
        },
        camposLayout: [{
            clave: "[Clave del estado]",
            nombre: "[Nombre del estado]",
            pais: "[Clave del país; ej. MEX, USA"
        }],
        model: {
            id: 0,
            clave: "",
            nombre: "",
            pais: "",
        },
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Utilerías",
                disabled: true,
                to: ""
            },
            {
                text: "Apendices",
                disabled: true,
                to: ""
            }
        ]

    }),
    computed: {
        datafiltered() {
            if (this.$refs.vuetable != null) {
                return this.$refs.vuetable.allFilteredData;
            } else {
                return this.datos.items;
            }

        },
    },
    methods: {
        render(url) {
            this.$router.push(url);
        },
        applyFilter() {

            Event.$emit('vue-tables.filter::porpais', this.sel_pais);

        },
        nombrePais: function (pais) {
            return (pais != undefined) ? pais.clave_m3 + " - " + pais.nombre : '';
        },
        openModal: function (type) {
            if (type === 1) {
                this.limpiarModel();
                this.update = false;
            } else {
                this.update = true;
            }
            this.modal = true;
        },

        limpiarModel: function () {
            for (var k in this.model) {
                this.model[k] = "";
            }
        },

        guardar() {
            var datos = this.model;
            datos["tabla"] = this.tabla;

            if (!this.$refs.form.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var metodo = "post";
                var urlCliente = this.URL;
                if (this.update == true) {
                    metodo = "put";
                    urlCliente += this.model.id + "/";
                }
                axios({
                        method: metodo,
                        url: urlCliente,
                        data: datos
                    })
                    .then(res => {
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "Los datos se guardaron correctamente",
                            footer: ""
                        });
                    })
                    .catch(error => {
                        var errores = "";
                        if (typeof error.response.data != "undefined") {
                            Object.keys(error.response.data).forEach(function (key) {
                                for (var k in error.response.data[key]) {
                                    errores += key + ": " + error.response.data[key][k];
                                    errores += "<br>";
                                }
                            });
                        }
                        this.$swal({
                            position: "center",
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al guardar los datos",
                            footer: errores
                            //showConfirmButton: false,
                        });
                        //console.log(error);
                    })
                    .then(() => {
                        this.cargar();
                        this.cargarPaisesEstados();
                        this.$root.$dialogLoader.hide();
                        this.modal = false;
                    });
            }
        },
        obtenerPais(id_pais) {
            let paises = this.paises.filter(function (e) {
                return e.id_pais == id_pais;
            });
            return paises.length > 0 ? (paises[0].clave_m3 + " - " + paises[0].nombre) : "N/A";
        },

        cargar: function () {
            var datos = {
                tabla: this.tabla
            };
            axios
                .post(this.$hostname + this.url_list, datos)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.datos.items = res.data;
                        for (var k in this.datos.items) {
                            this.datos.items[k].pais = this.obtenerPais(this.datos.items[k].pais);
                        }
                    }
                })
                .catch(err => {
                   
                    console.log(err);
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },

        getRegistro: function (id_registro) {
            let tabla = this.tabla;
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios
                .get(this.URL + id_registro + "/", {
                    params: {
                        tabla: tabla
                    }
                })
                .then(response => {
                    this.model = response.data;
                    var obj = response.data;
                    this.openModal(2); //ACTUALIZAR
                })
                .catch(error => {
                    console.log(error);
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el registro",
                        footer: ""
                    });
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                });
        }, //getRegistro

        deleteRegistro: function (id_registro) {
            let tabla = this.tabla;
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value) {
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    axios
                        .delete(this.URL + id_registro + "/", {
                            params: {
                                tabla: tabla
                            }
                        })
                        .then(response => {
                            this.cargar();
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "El registro se eliminó correctamente.",
                                //position: 'bottom-end',
                                //timer: 3000,
                                //showConfirmButton: false,
                                footer: ""
                            });
                        })
                        .catch(error => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al eliminar el registro",
                                footer: ""
                            });
                        })
                        .then(() => {
                            this.$root.$dialogLoader.hide();
                        });
                }
            });
        }, //delete
        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (isLt2M) {
                return true;
            }
            this.$swal({
                type: "warning",
                title: "¡Operación no Permitida!",
                text: "El archivo no debe ser mayor a 2MB.",
                footer: ""
            });
            return false;
        },
        validaCargaLayout: async function (results) {
            var thisObject = this;
            var errores = 0;
            var renglonesLeidos = 0;
            var erroresText = '';
            try {

                for (var k in results) {
                    renglonesLeidos++;
                    if (results[k]["clave"] != undefined && results[k]["clave"].toString().trim().length > 10) {
                        errores++;
                        erroresText += "- La clave de estado \"" + results[k]["clave"] + "\" no debe ser mayor a 10 caracteres.<br>";
                    } else if (results[k]["clave"] == undefined || (results[k]["clave"] != undefined && results[k]["clave"].toString().trim().length == 0)) {
                        errores++;
                        erroresText += "- La clave de estado no debe estar vacía.<br>";
                    }

                    if (results[k]["pais"] != undefined) {
                        let verificaPaises = await thisObject.verificaComboPaises(results[k]["pais"], results[k]["clave"]);
                        if (verificaPaises.toString().trim().length > 0) {
                            errores++;
                            if (erroresText.indexOf(verificaPaises) == -1)
                                erroresText += verificaPaises;
                        }
                    } else {
                        errores++;
                        erroresText += "- La clave de pais no debe estar vacía.<br>";
                    }
                }

                if (renglonesLeidos == 0) {
                    errores++;
                    erroresText += "- No hay datos en el layout. Verifique que exista información a partir del 3er renglón.\n";
                }

                return ({
                    "errores": errores,
                    "erroresText": erroresText
                });

            } catch (error) {
                console.log(error);
                thisObject.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
            }
            //}); //promise      
        },
        handleSuccess: async function ({
            results,
            header
        }) {
            /*for (var k in results){            
                  results[k]['user_updated'] = this.$local_storage.get('username'); 
                  //console.log("Key is " + k + ", value is" + results[k]);  
              }*/
            var errores = 0;
            var erroresText = '';
            this.importData = [];
            try {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                let validaciones = await this.validaCargaLayout(results);
                if (validaciones.errores > 0) {
                    this.$swal({
                        type: "warning",
                        title: "¡Operación no Permitida!",
                        text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo.",
                        footer: validaciones.erroresText,
                    });
                    this.$root.$dialogLoader.hide();
                } else {
                    for (var k in results) {
                        var id_pais = results[k]["pais"] != undefined ? await this.verificaPais(results[k]["pais"], 'id') : '';
                        results[k]["pais"] = id_pais;
                    }
                    let tabla = this.tabla;
                    this.importData = results;
                    axios
                        .post(this.URL + "importar_apendice/?tabla=" + tabla, this.importData)
                        .then(() => {
                            this.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "Los datos se guardaron correctamente",
                                footer: ""
                            });
                        })
                        .catch(err => {
                            var errores = "";
                            if (typeof err.response.data != "undefined") {
                                for (var i = 0; i < err.response.data.length; i++) {
                                    Object.keys(err.response.data[i]).forEach(function (key) {
                                        errores +=
                                            "Fila " +
                                            (i + 2) +
                                            " => " +
                                            key +
                                            ": " +
                                            err.response.data[i][key];
                                        errores += "<br>";
                                    });
                                }
                            }
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Verifique que los encabezados correspondan con el layout y que no existan registros duplicados.",
                                footer: errores
                            });
                        })
                        .then(() => {
                            this.cargar();
                            this.cargarPaisesEstados();
                            this.$root.$dialogLoader.hide();
                        });
                }

            } catch (error) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
                this.$root.$dialogLoader.hide();
            }
        },
        cargarPaises: function () {
            axios
                .get(this.$hostname + "paises/")
                .then(res => {
                    if (typeof res.data !== "undefined") this.paises = res.data;
                    else {
                        this.$swal({
                            type: "warning",
                            title: "Aviso",
                            text: "No se han ingresado datos al catálogo de países",
                            footer: ""
                        });
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el catálogo de países.",
                        footer: ""
                    });
                    console.log(err);
                }).then(() => {
                    this.cargarEstados();
                });
        },
        cargarEstados: function () {
            axios
                .get(this.$hostname + "estados/")
                .then(res => {
                    if (typeof res.data !== "undefined")
                        this.estados = res.data;
                    else {
                        this.$swal({
                            type: "warning",
                            title: "Aviso",
                            text: "No se han ingresado datos al catálogo de estados",
                            footer: ""
                        });
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el catálogo de estados.",
                        footer: ""
                    });
                    console.log(err);
                }).then(() => {
                    this.cargar();
                });
        },
        verificaPaisesVacios: function (clave_pais, clave_estado) {
            var erroresText = '';
            if (clave_estado != undefined && clave_pais == undefined)
                erroresText += "- La clave estado \"" + clave_estado + "\" no debe tener el país vacío.<br>";
            return erroresText;

        },
        verificaComboPaises: async function (clave_pais, clave_estado) {
            var erroresText = this.verificaPaisesVacios(clave_pais, clave_estado);
            let verificaP = await this.verificaPais(clave_pais, '');
            if (verificaP == 0) {
                erroresText += "- La clave país \"" + clave_pais + "\" no existe en el sistema.<br>";
            } else {
                let id_pais = await this.verificaPais(clave_pais, 'id');
                if (clave_estado != undefined) {
                    let verificaE = await this.verificaEstado(clave_estado, id_pais, '');
                    if (verificaE != 0) {
                        erroresText += "- La clave estado \"" + clave_estado + "\" ya existe.<br>";
                    }
                }
            }
            return erroresText;
        },
        verificaPais: function (clave_pais, opcion) {
            var thisObject = this;
            return new Promise(function (resolve, reject) {
                if (clave_pais == undefined)
                    resolve(0);

                var search = thisObject.paises.filter(function (e) {
                    return e.clave_m3.toString().trim().toLowerCase() == clave_pais.toString().trim().toLowerCase();
                });
                if (opcion == 'id')
                    resolve(search.length > 0 ? search[0].id_pais : '');
                else
                    resolve(search.length);
            });

        },
        verificaEstado: function (clave_estado, id_pais, opcion) {
            var thisObject = this;
            return new Promise(function (resolve, reject) {
                if (clave_estado == undefined)
                    resolve(0);

                var search = thisObject.estados.filter(function (e) {
                    return e.clave.toString().trim().toLowerCase() == clave_estado.toString().trim().toLowerCase() &&
                        e.pais == id_pais;
                });
                if (opcion == 'id')
                    resolve(search.length > 0 ? search[0].id_estado : '');
                else
                    resolve(search.length);
            });
        },
        selectComboPais(id) {
            this.model.pais = id;
        },
        cargarPaisesEstados: function () {
            axios
                .get(this.$hostname + "estados/get_estados_paises/")
                .then(res => {
                    if (typeof res.data !== "undefined") this.paises_estados = res.data;
                    else {
                        this.$swal({
                            type: "warning",
                            title: "Aviso",
                            text: "No se han ingresado datos al catálogo de países",
                            footer: ""
                        });
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el catálogo de países.",
                        footer: ""
                    });
                    console.log(err);
                }).then(() => {
                    this.cargarEstados();
                });
        },
    }, //methods

    created: function () {
        this.URL = this.$hostname + this.url_actions;
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        this.id_cliente = this.$local_storage.get("id_cliente");
        if (this.id_cliente > 0 && this.tabla != 2) {
            //Los clientes no pueden modificar los apendices, excepto el de 2-Unidades de Medida y (por definir PILOS)
            this.editable = false;
            delete this.options.headings["actions"];
            var key = 0;
            for (var k in this.columns) {
                if (this.columns[k] == "actions") key = k;
            }
            if (key > 0) delete this.columns[key];
        }
        this.cargarPaises();
        this.cargarPaisesEstados();
    }
};
</script>

<style>
.VueTables__limit {
    display: none;
}

.v-text-field.v-text-field--solo .v-input__control {
    min-height: 32px !important;
}

.v-text-field.v-text-field--solo .v-input__control {
    min-height: 32px !important;
}
</style>
<style scoped>
.VueTables >>> thead th {
  white-space: normal !important;
}

.VueTables >>> tbody td{
  white-space: normal !important;
}
</style>